import { render } from "./SpendingCard.vue?vue&type=template&id=3dc898d4&scoped=true"
import script from "./SpendingCard.vue?vue&type=script&lang=js"
export * from "./SpendingCard.vue?vue&type=script&lang=js"

import "./SpendingCard.vue?vue&type=style&index=0&id=3dc898d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc898d4"]])

export default __exports__